/* eslint-disable indent */
import React, { useEffect, useState, useRef, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";
import moment from "moment";

// import ReactHTMLTableToExcel from "react-html-table-to-excel";

import { getReportingManagersByLocationId } from "../../../redux/actions/reportingActions";
import { helperFunction } from "../../../constant/helper";
import {
  renderDate,
  TimeStampIntoHours
} from "../../../constant/helper/helper";
import { loginTypeConstant } from "../../../constant/loginType/loginTypeConstant";
import { reportingActions } from "../../../redux/actions";
import { ReportingTypes } from "../../../redux/type/type";
import AttendanceUserList from "../../attendance/attendanceSheet/AttendanceUserList";
import Card from "../../../component/card/Card";
import TopInputs from "./TopInputs";
import Starter from "../../../component/Starter";

const initialState = {
  toDate: "",
  Filter: "",
  fromDate: "",
  locationId: "",
  sendMail: false,
  dataFormat: "ABP",
  convertByTime: false,
  reportingMangerId: ""
};

const AllReports = () => {
  const componentRef = useRef();

  const dispatch = useDispatch();

  const loginType = localStorage.loginType;
  const locationID = localStorage.locationId;

  const [values, setValues] = useState(initialState);
  const [dateDifference, setDateDifference] = useState(0);
  const [dateArrayState, setDateArrayState] = useState([]);
  const [attendanceReport, setAttendanceReport] = useState([]);

  const {
    toDate,
    fromDate,
    sendMail,
    dataFormat,
    locationId,
    foundManagers,
    convertByTime,
    reportingLoading,
    reportingMangerId,
    attendanceSheetReports
  } = useSelector((state) => state.reporting);
  const { locationError, locations } = useSelector(
    (state) => state.location
  );
  const { currentUser } = useSelector((state) => state.auth);

  useEffect(() => {
    if (locationError) {
      helperFunction.toastHelper("error", locationError);
    }
  }, [locationError]);

  useEffect(() => {
    setValues({
      ...values,
      toDate,
      fromDate,
      sendMail,
      locationId,
      dataFormat,
      convertByTime,
      reportingMangerId
    });
  }, [
    toDate,
    fromDate,
    sendMail,
    locationId,
    dataFormat,
    convertByTime,
    reportingMangerId
  ]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "locationId") {
      // console.log(value);
      dispatch(getReportingManagersByLocationId(value, loginType));
    }
    setValues({
      ...values,
      [name]: value
    });
  };

  useEffect(() => {
    if (attendanceSheetReports) {
      setAttendanceReport(
        attendanceSheetReports.map((sheet) => {
          const dailyPointsArrayState = [];
          const dailyPoints = [];
          sheet.attendanceData.dailyPointsArray.map((date) => {
            return dailyPointsArrayState.push({
              Date: moment(date.Date).format("DD/MM/yyyy"),
              Points: date?.Points,
              createdAs: date?.createdAs,
              inTime: date?.inTime || "-",
              outTime: date?.outTime || "-"
            });
          });
          const obj = _.mapKeys(dailyPointsArrayState, "Date");
          dateArrayState.forEach((dateValue) => {
            const pointsToInsert =
              typeof obj[dateValue] === "undefined"
                ? null
                : obj[dateValue].Points;
            const createdAsToInsert =
              typeof obj[dateValue] === "undefined"
                ? null
                : obj[dateValue].createdAs;
            const inTime =
              typeof obj[dateValue] === "undefined"
                ? "-"
                : TimeStampIntoHours(obj[dateValue].inTime);
            const outTime =
              typeof obj[dateValue] === "undefined"
                ? "-"
                : TimeStampIntoHours(obj[dateValue].outTime);

            return dailyPoints.push({
              Date: dateValue,
              Points: pointsToInsert,
              createdAs: createdAsToInsert,
              inTime: inTime,
              outTime: outTime
            });
          });
          return {
            Location: sheet.locationName,
            workerId: sheet.attendanceData._id.workerId,
            dailyPointsArray: dailyPoints,
            employeeId: sheet.attendanceData._id.employeeId,
            total_duration: sheet?.attendanceData?.total_duration,
            workerFullName: sheet.employee,
            total_shift_points:
              sheet?.attendanceData?.total_shift_points,
            workerDepartment: sheet.department,
            workerDesignation: sheet.designation
          };
        })
      );
    }
  }, [attendanceSheetReports]);

  const onSubmit = (e) => {
    e.preventDefault();
    const {
      toDate,
      fromDate,
      sendMail,
      locationId,
      dataFormat,
      convertByTime,
      reportingMangerId
    } = values;
    if (fromDate === "" || toDate === "") {
      const errorData = {
        data: {
          message: "From Date,To Date or Location is not selected"
        },
        status: 400
      };
      return dispatch({
        type: ReportingTypes.REPORTINGS_GET_ERRORS,
        payload: errorData
      });
    } else {
      const diffTime = Math.abs(
        new Date(toDate) - new Date(fromDate)
      );
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      setDateDifference(diffDays);
      const dateArray = renderDate(values);
      setDateArrayState(dateArray);
      dispatch(reportingActions.setReportingLoading(true));
      dispatch(reportingActions.clearReportingErrors());
      dispatch(reportingActions.clearReportingResult());
      // console.log(convertByTime, sendMail);

      if (
        currentUser.workerDepartment !== "SUPER ADMIN" &&
        currentUser.workerDesignation !== "SUPER ADMIN"
      ) {
        dispatch(
          reportingActions.getAttendanceSheetReports(
            fromDate,
            toDate,
            locationID,
            loginType,
            reportingMangerId,
            dataFormat,
            convertByTime,
            sendMail
          )
        );
      } else {
        dispatch(
          reportingActions.getAttendanceSheetReports(
            fromDate,
            toDate,
            locationId,
            loginType,
            reportingMangerId,
            dataFormat,
            convertByTime,
            sendMail
          )
        );
      }
    }
  };

  return (
    <Starter
      topBarTitle="All Reports"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Access Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Access</a>
          </li>
          <li className="breadcrumb-item active">All Reports</li>
        </Fragment>
      }
    >
      <Card>
        <TopInputs
          values={values}
          onSubmit={onSubmit}
          locations={locations}
          currentUser={currentUser}
          foundManagers={foundManagers}
          handleInputChange={handleInputChange}
        />

        <AttendanceUserList
          values={values}
          loginType={loginType}
          excelRef={componentRef}
          loading={reportingLoading}
          dateDifference={dateDifference}
          dateArrayState={dateArrayState}
          loginTypeConstant={loginTypeConstant}
          setDateArrayState={setDateArrayState}
          attendanceSheetData={attendanceReport}
        />
      </Card>
    </Starter>
  );
};

export default AllReports;
